import { useQuery } from '@tanstack/react-query';
import { getBrandId } from 'src/helpers/getBrandId/getBrandId';
import { getEvent } from 'src/api/getEvent';
import { IEvent } from 'src/api/getEvent/types';
import { QueryKeys } from '../QueryKeys';
import { NotificationStatus } from 'src/api/getEvents';

const PENDING_STATUS_POLL_INTERVAL_MS = 15000;

export const useEvent = (eventId?: string) => {
  return useQuery<IEvent, Error>({
    queryKey: [QueryKeys.events, getBrandId(), eventId],
    queryFn: () => {
      if (!eventId) {
        throw new Error('Event ID is required');
      }
      return getEvent(eventId);
    },
    enabled: !!eventId,
    refetchInterval: (data) => (data?.status === NotificationStatus.PENDING ? PENDING_STATUS_POLL_INTERVAL_MS : null),
  });
};
